var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbout2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 46,
    viewBox: "0 0 40 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_33_101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.8571 20.0001C32.8588 17.7407 32.265 15.5207 31.1356 13.5639C30.0062 11.607 28.381 9.98235 26.4239 8.85349C24.4667 7.72462 22.2466 7.13143 19.9872 7.13367C17.7279 7.13592 15.509 7.73351 13.554 8.86626C11.5991 9.99901 9.97722 11.6269 8.8517 13.586C7.72619 15.5451 7.1368 17.7662 7.14291 20.0256C7.14902 22.2849 7.7504 24.5028 8.8865 26.4558C10.0226 28.4088 11.6533 30.0279 13.6143 31.1501L14.2857 38.5715H25.7143L26.3857 31.1501C28.3505 30.0257 29.9836 28.4026 31.1199 26.4448C32.2562 24.4869 32.8555 22.2638 32.8571 20.0001Z",
    fill: "white",
    stroke: "#2D142C",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.7143 38.5714H14.2857V45H25.7143V38.5714Z",
    fill: "white",
    stroke: "#2D142C",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.2857 40.7142H25.7143",
    stroke: "#2D142C",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.2857 42.8572H25.7143",
    stroke: "#2D142C",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20 0V4.28571",
    stroke: "#2D142C",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M40 20H35.7143",
    stroke: "#2D142C",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M0 20H4.28571",
    stroke: "#2D142C",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M5.85714 5.85718L8.88571 8.88575",
    stroke: "#2D142C",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M34.1429 5.85718L31.1143 8.88575",
    stroke: "#2D142C",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M30 22.1429V17.8571H27.5571C27.3832 17.2702 27.1436 16.7047 26.8429 16.1714L28.5714 14.4429L25.5571 11.4286L23.8286 13.1429C23.2953 12.8421 22.7298 12.6025 22.1429 12.4286V10H17.8571V12.4429C17.2702 12.6168 16.7047 12.8564 16.1714 13.1571L14.4429 11.4286L11.4286 14.4429L13.1571 16.1714C12.8564 16.7047 12.6168 17.2702 12.4429 17.8571H10V22.1429H12.4429C12.6168 22.7298 12.8564 23.2953 13.1571 23.8286L11.4286 25.5571L14.4429 28.5714L16.1714 26.8429C16.7047 27.1436 17.2702 27.3832 17.8571 27.5571V30H22.1429V27.5571C22.7298 27.3832 23.2953 27.1436 23.8286 26.8429L25.5571 28.5714L28.5714 25.5571L26.8571 23.8286C27.1578 23.2953 27.3975 22.7298 27.5714 22.1429H30Z",
    fill: "white",
    stroke: "#EE4540",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M20 22.8571C21.578 22.8571 22.8571 21.5779 22.8571 20C22.8571 18.422 21.578 17.1428 20 17.1428C18.422 17.1428 17.1429 18.422 17.1429 20C17.1429 21.5779 18.422 22.8571 20 22.8571Z",
    fill: "white",
    stroke: "#EE4540",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 45.7143,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout2);
export default __webpack_public_path__ + "static/media/about2.6f18bf0ce5b4ec2349ad69852fe30c3d.svg";
export { ForwardRef as ReactComponent };